// @ts-nocheck
import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import {
    ShipmentCollectionModel,
    ShipmentModel,
    ShipmentStatusCollectionModel,
} from "@insite/client-framework/Types/ApiModels";

export interface GetShipmentsApiParameter extends ApiParameter, HasPagingParameters {
    greifOrderNumber?: string;
    purchaseOrderNumber?: string;
    shipTo?: string;
    fromDate?: string;
    toDate?: string;
    isNextDaysFilter?: boolean;
    deliveryStatuses?: string[];
    status?: string;
    customerSequence?: string;
}

export interface GetShipmentStatusesApiParameter extends ApiParameter {}

const shipmentUrl = "/api/v1/custom/shipment";

export async function getShipments(parameter: GetShipmentsApiParameter): Promise<ShipmentCollectionModel> {
    // can't send empty status array to API
    if (parameter.deliveryStatuses && parameter.deliveryStatuses.length === 0) {
        delete parameter.deliveryStatuses;
    }

    delete (parameter as any).onComplete;
    const shipments = await get<ShipmentCollectionModel>(shipmentUrl, parameter);
    shipments.shipments?.forEach(o => {
        cleanShipment(o);
    });
    return shipments;
}

export async function getShipmentStatuses(parameter: GetShipmentStatusesApiParameter) {
    const shipmentStatuses = await get<ShipmentStatusCollectionModel>(`${shipmentUrl}/shipmentstatuses`, parameter);
    return shipmentStatuses;
}

function cleanShipment(shipmentModel: ShipmentModel) {
    shipmentModel.deliveryDate = shipmentModel.deliveryDate ? new Date(shipmentModel.deliveryDate) : "";
}
